import WorkOrdersPage from "./WorkOrdersPage";

export default WorkOrdersPage;
